import { Instagram, Music2, Facebook, CloudSun, Disc3 } from "lucide-react";

export const FooterSection = () => {
  return (
    <footer data-testid="footer-section" className="py-16 md:py-24 tracing-border">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          {/* Brand */}
          <div>
            <img src="/images/alchemist-logo.png" alt="Alchemist (CA)" className="h-10 w-auto mb-4" />
            <p className="font-sub text-[10px] text-white/30 tracking-widest mb-6">(CA) — TORONTO</p>
            <p className="font-body text-sm text-white/30 leading-relaxed">
              Music producer & DJ based in Toronto. Crafting sonic experiences that blur
              the line between the organic and the electronic.
            </p>
          </div>

          {/* Links */}
          <div>
            <p className="font-sub text-[10px] text-white/30 tracking-widest mb-6">NAVIGATION</p>
            <div className="flex flex-col gap-4">
              {["About", "Music", "Releases", "Remixes", "EPK", "Events"].map((link) => (
                <a
                  key={link}
                  href={`#${link.toLowerCase()}`}
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(`#${link.toLowerCase()}`)?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="font-sub text-xs text-white/40 hover:text-white tracking-widest transition-colors duration-300"
                >
                  {link.toUpperCase()}
                </a>
              ))}
              <a
                href="/admin"
                className="font-sub text-xs text-white/15 hover:text-white/40 tracking-widest transition-colors duration-300"
              >
                ADMIN
              </a>
            </div>
          </div>

          {/* Connect */}
          <div>
            <p className="font-sub text-[10px] text-white/30 tracking-widest mb-6">CONNECT</p>
            <div className="flex flex-wrap gap-4">
              <a
                data-testid="social-spotify"
                href="https://open.spotify.com/artist/06NV3L7olz3ocY4pe5GUFZ"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-white/10 flex items-center justify-center hover:border-white/30 hover:bg-white/5 transition-colors duration-300"
                title="Spotify"
              >
                <Music2 className="w-4 h-4 text-white/50" />
              </a>
              <a
                data-testid="social-instagram"
                href="https://www.instagram.com/dj__alchemist"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-white/10 flex items-center justify-center hover:border-white/30 hover:bg-white/5 transition-colors duration-300"
                title="Instagram"
              >
                <Instagram className="w-4 h-4 text-white/50" />
              </a>
              <a
                data-testid="social-facebook"
                href="https://www.facebook.com/DeejayAlchemist/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-white/10 flex items-center justify-center hover:border-white/30 hover:bg-white/5 transition-colors duration-300"
                title="Facebook"
              >
                <Facebook className="w-4 h-4 text-white/50" />
              </a>
              <a
                data-testid="social-soundcloud"
                href="https://soundcloud.com/gunjan-goel-665914876"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-white/10 flex items-center justify-center hover:border-white/30 hover:bg-white/5 transition-colors duration-300"
                title="SoundCloud"
              >
                <CloudSun className="w-4 h-4 text-white/50" />
              </a>
              <a
                data-testid="social-beatport"
                href="https://www.beatport.com/artist/alchemist-ca/1045911"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-white/10 flex items-center justify-center hover:border-white/30 hover:bg-white/5 transition-colors duration-300"
                title="Beatport"
              >
                <Disc3 className="w-4 h-4 text-white/50" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-sub text-[10px] text-white/15 tracking-widest">
            &copy; {new Date().getFullYear()} ALCHEMIST (CA). ALL RIGHTS RESERVED.
          </p>
          <p className="font-sub text-[10px] text-white/10 tracking-widest">
            TORONTO, CANADA
          </p>
        </div>
      </div>
    </footer>
  );
};
